module.exports = __webpack_public_path__ + "static/media/smart5.561aa74d.png";